import React, { useContext } from 'react';

import {
  Badge,
  Card,
  Group,
  Progress,
  ScrollArea,
  Stack,
  Table,
  Text,
  Title
} from '@mantine/core';

import { WsDecodeContext, WsDecodeContextProps } from "../components/Deliver/DecodeContext";

import { deterministicRandomInt, pairSeed, pairSeedWithString, randomIntInRange, randomNonZeroInt } from "../components/Deliver/Pages/decode-data";

import { getLocalAuthorityList } from "../decode-data-hwb";

import './TableReportMantineV6.scss';







export function rgbaTransparency(color: string, level: number): string {
  const clamped = Math.min(10, Math.max(1, Math.round(level)));
  const alpha = clamped / 10;
  return `rgba(${color}, ${alpha})`;
}

export function functionRed(color: string, level: number): string {
  const clamped = Math.min(5, Math.max(1, level));
  const alpha = (5 - clamped) / 4;
  return `rgba(${color}, ${alpha})`;
}

export function functionGreen(color: string, level: number): string {
  const clamped = Math.min(10, Math.max(5, level));
  const alpha = (clamped - 5) / 5;
  return `rgba(${color}, ${alpha})`;
}




const red = '251, 87, 87';

const green = '151, 227, 37';













type DecodeTableReportCellProps = {
  // key: string;
  // rowIndex:    number;
  // columnIndex: number;
  score: number;
};

const DecodeTableReportCell = (props: DecodeTableReportCellProps) => {

  const backgroundColor = props.score > 5 ? functionGreen(green, props.score) : functionRed(red, props.score);

  return (
    <td
      // key={props.key}
      className="decode-table-report-column decode-table-report-column-score"
    >
      <div
        className="decode-table-report-column-score-cell"
        style={{
          transition: 'background-color 2500ms cubic-bezier(0.19, 1, 0.22, 1)',
          backgroundColor
        }}
      >
        {props.score}
      </div>
    </td>
  );
};






interface DecodeTableReportScores {
  score3: number;
  score4: number;
  score5: number;
  score6: number;
}

const getScores = (rowIndex: number, unique: string): DecodeTableReportScores => {

  return {
    score3: randomIntInRange(1, 10, pairSeedWithString(rowIndex, 3, unique)),
    score4: randomIntInRange(1, 10, pairSeedWithString(rowIndex, 4, unique)),
    score5: randomIntInRange(1, 10, pairSeedWithString(rowIndex, 5, unique)),
    score6: randomIntInRange(1, 10, pairSeedWithString(rowIndex, 6, unique)),
  };
};

const getGreenCount = (scores: DecodeTableReportScores): number => {

  let count = 0;

  if (scores.score3 >= 5) {
    count++;
  }

  if (scores.score4 >= 5) {
    count++;
  }

  if (scores.score5 >= 5) {
    count++;
  }

  if (scores.score6 >= 5) {
    count++;
  }

  return count;
};









export const getUnique = (decodeContext: WsDecodeContextProps | undefined) => {

  const uniqueDateRange = `${decodeContext?.selectedDateRange.start?.toISOString()}-${decodeContext?.selectedDateRange.end?.toISOString()}`;

  const unique = `${uniqueDateRange}-${decodeContext?.selectedRegionalPartnershipId}-${decodeContext?.selectedLocalAuthorityId}-${decodeContext?.selectedSchoolTypeId}-${decodeContext?.selectedSchoolId}`;

  return unique;
};










const WipTableReportMantineV6 = (props: { name: string, description: string }) => {

  const decodeContext = useContext(WsDecodeContext);

  return (
    <section className="wip-table-report-mantine-v6">
      <Card withBorder shadow="sm" radius="lg" padding="lg">
        <Stack spacing="lg">
          <Group position="apart" align="flex-start">
            <Stack spacing={4}>
              <Badge
                color="blue"
                variant="light"
                className="wip-table-report-mantine-v6__heading-badge"
              >
                Report
              </Badge>
              <Title order={2}>{props.name}</Title>
              <Text color="dimmed" size="sm">
                {props.description}
              </Text>
            </Stack>

            <Badge color="teal" variant="filled">
              Updated on June 3
            </Badge>
          </Group>

          <ScrollArea>
            <Table
              striped
              highlightOnHover
              withBorder
              withColumnBorders
              verticalSpacing="sm"
              className="wip-table-report-mantine-v6__table"
            >
              <thead>
                <tr>
                  <th></th>
                  {/* <th className="decode-table-report-column">Pupils on Roll</th> */}
                  <th className="decode-table-report-column">Copilot Usage</th>
                  <th className="decode-table-report-column">NesGPT</th>
                  <th className="decode-table-report-column">Enterprise Services</th>
                  <th className="decode-table-report-column">360 Tools</th>
                  <th className="decode-table-report-column">Green Count</th>
                </tr>
              </thead>
              <tbody>

                {/* {tableReportMantineV6Rows} */}

                {
                  getLocalAuthorityList().map((localAuthority, rowIndex) => {

                    const unique = getUnique(decodeContext);

                    // console.log(`unique: ${unique}`);

                    // const seed = pairSeedWithString(rowIndex, columnIndex, unique);
                    // const seed = pairSeed(rowIndex, columnIndex);

                    // const score = randomIntInRange(1, 10, pairSeedWithString(rowIndex, columnIndex, unique));

                    const scores = getScores(rowIndex, unique);

                    const greenCount = getGreenCount(scores);

                    return (
                      <tr key={`decode-local-authority-${rowIndex}-${localAuthority.id}`}>
                        {/* <td>{localAuthority.name} ({localAuthority.id})</td> */}
                        <td>{localAuthority.name}</td>
                        {/* <td className="decode-table-report-column">{randomIntInRange(1000, 30000, pairSeed(rowIndex, 1))}</td> */}
                        <DecodeTableReportCell score={scores.score3} />
                        <DecodeTableReportCell score={scores.score4} />
                        <DecodeTableReportCell score={scores.score5} />
                        <DecodeTableReportCell score={scores.score6} />
                        <td className="decode-table-report-column">{greenCount}</td>
                      </tr>
                    );
                  })
                }

                {/* <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr> */}
              </tbody>
            </Table>
          </ScrollArea>
        </Stack>
      </Card>
    </section>
  )
};








export {
  WipTableReportMantineV6
};
